var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShowDrag)?_c('div',{directives:[{name:"drag",rawName:"v-drag"}],staticClass:"drag-box",attrs:{"id":"drag"}},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.isShowDrag = false}}},[_vm._v("关闭")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }